export const ALGO_CONFIG = {
	GROUP_RADIUS_DEFAULT: 50,
}
